import { render, staticRenderFns } from "./StepStockActionPreview.vue?vue&type=template&id=15f5d901&scoped=true&"
import script from "./StepStockActionPreview.vue?vue&type=script&lang=js&"
export * from "./StepStockActionPreview.vue?vue&type=script&lang=js&"
import style0 from "./StepStockActionPreview.vue?vue&type=style&index=0&id=15f5d901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5d901",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
